import { ApiRequestGet } from "../../data/network/services/ApiRequestGet";
import { profileDetailsAction } from "../../data/redux/action/profileDetailsAction";
import { SUCCESS } from "../../presentation/resources/constantsManager";

export const profileDetailsService = () => (dispatch) => {
  ApiRequestGet.getClientDetails()
    .then((res) => {
      dispatch(profileDetailsAction(res?.data));
      // if (res.status === SUCCESS) {
      // }
    })
    .catch((err) => {
      console.log(err, "err");
    });
};
